<template>
    <v-card>
        <v-card-title primary-title>
            <div>
                <h3 class="headline mb-0">Passwort ändern</h3>
            </div>
        </v-card-title>
        <v-card-text>
            <v-form v-model="valid">
                <v-text-field label="Passwort"
                              :disabled="disabled"
                              v-model="password.first"
                              :rules="passwordRules"
                              type="password"
                              @keyup.enter="save"
                              required
                ></v-text-field>
                <v-text-field label="Passwort wiederholen"
                              :disabled="disabled"
                              ref="password-confirmation"
                              v-model="password.second"
                              :rules="passwordRepeatRules"
                              @keyup.enter="save"
                              type="password"
                              required
                ></v-text-field>

                <v-btn block primary @click="save" :disabled="disabled || !valid || password.first !== password.second || !user_id || loading" :loading="loading">Speichern</v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            user: {
                type: Object,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            valid: false,
            loading: false,
            token: null,
            password: {
                first: '',
                second: ''
            },
            passwordRules: [
                v => !!v || 'Passwort fehlt',
                v => v.length >= 6 || 'Das Passwort muss mindestens 6 Zeichen lang sein'
            ],
            passwordRepeatRules: [
                v => !!v || 'Passwort fehlt'
            ]
        }),
        computed: {
            // a computed getter
            user_id: function () {
                if (this.$route.params.userId !== undefined) {
                    return this.$route.params.userId;
                }

                if (this.user) {
                    return this.user.id;
                }
            },
        },
        mounted() {
            if (this.$route.params.token !== undefined) {
                this.token = this.$route.params.token;
            }
        },
        methods: {
            save() {
                if (!this.valid || this.loading) {
                    return false;
                }

                this.loading = true;

                let data = {
                    password: this.password.first
                };
                if (this.token) {
                    data.token = this.token;
                }

                axios.post(`/api/v1/users/${this.user_id}/password`, data).then(response => {

                    if (!response.data.success) {
                        this.loading = false;
                        return;
                    }

                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: 'Passwort erfolgreich geändert'
                    });

                    this.loading = false;

                    if (this.token) {
                        this.$router.push('/login');
                    }

                }, errorResponse => {
                    console.error(errorResponse);
                    this.loading = false;
                    this.$store.commit('snackBar', {
                        color: 'error',
                        text: 'Fehler beim speichern'
                    });
                });
            }
        }
    }
</script>
